import React, { useEffect, useState } from 'react'
import { setHeaderTitle, setBackHandler } from '../../helpers/header.helper';
import { ChannelAccountModel, ChannelWelcomeStatusModel } from '../../models/channels/channels.model';
import { DialogHeaders } from '../shared/constants';
import ChatWidgetTitle from './chat-widget-title.component';
import EmbeddCode from './embed-code.component';
import LiveChatValidate from './live-chat-validate.component';
import { Box, Step, StepLabel, Stepper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import VisitorDetailsComponent from './live-chat-visitor-details.component';
import * as selector from '../../selectors/selectors';
import { ChannelUserService } from '../../services/ChannelUserService';
import { useSelector } from 'react-redux';
import { ChannelPlanModel } from '../../models/users.model';

interface IProps extends ChannelAccountModel {
    IsTeamsApp: boolean;
}

const LiveChatComponent: React.FC<IProps> = (props: IProps) => {
    const navigate = useNavigate();
    const location = useLocation()
    const IsWordPress: boolean = useSelector(selector.IsWordpress)
    const PlanDetails: ChannelPlanModel = useSelector(selector.PlanDetails)

    const [activeStep, setActiveStep] = useState<number>(0)
    const [stepData, setStepData] = useState<any>()
    const [channelRowData, setChannelRowData] = useState<ChannelAccountModel>()
    const [premiumFeatures, setPremiumFeatures] = useState<boolean>(false)

    useEffect(() => {
        if (!!location?.state) {
            setChannelRowData(location.state)
        }
    }, [location?.state])

    const setBack = (index) => {
        if (index < activeStep)
            setActiveStep(index)
    }

    const handleNext = (data?: any) => {
        setActiveStep(activeStep + 1);
        setStepData({ ...stepData, ...data })
    }


    useEffect(() => {
        setHeaderTitle(DialogHeaders.LIVE_CHAT)
        setBackHandler(() => navigate(-1))
    }, [])

    const handleBack = (data?: any) => {
        setActiveStep(activeStep - 1);
        setStepData({ ...stepData, ...data })
    }

    useEffect(() => {
        setPremiumFeatures(PlanDetails.FeatureKeys?.includes("customize-live-chat"))
    }, [])

    const steps = [
        {
            Label: `Chat Widget Title`,
            Hide: false,
            component: <ChatWidgetTitle HandleNext={handleNext} Channel={channelRowData} StepData={stepData} PremiumFeatures={premiumFeatures} />
        },
        {
            Label: `Visitor Details`,
            Hide: !premiumFeatures,
            component: <VisitorDetailsComponent HandleNext={handleNext} StepData={stepData} Channel={channelRowData} HandleBack={handleBack} />
        },
        {
            Label: `Embed Code`,
            Hide: !!channelRowData,
            component: <EmbeddCode HandleNext={handleNext} StepData={stepData} />
        },
        {
            Label: `Validate`,
            Hide: !!channelRowData || IsWordPress,
            component: <LiveChatValidate HandleNext={handleNext} WidgetTitle={stepData?.WidgetTitle} ChannelId={stepData?.ChannelID} />
        },
    ]

    return (
        <div className=' bg-color-current-plan-background h-p-98 p-2'>
            {!(!premiumFeatures && !!channelRowData) && <Box className='d-flex flex-direction align-center h-p-10'>
                <Stepper activeStep={activeStep} alternativeLabel className={'w-80 live-chat-stepper'} >
                    {steps.filter(x => !x.Hide).map((step, index) => (
                        <Step key={index}>
                            <StepLabel className={'h3-regular'}>{step.Label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            }
            <div className='h-p-90'>
                {steps.filter(x => !x.Hide)[activeStep].component}
            </div>
        </div>
    )
}

export default LiveChatComponent;